import $ from 'jquery'

$.fn.bhubValidate = function (options) {
  const defaultSettings = {
    errorPlacement: function (error, element) {
      if (element.hasClass('bhub-custom-date-field__input')) {
        element.parents('.booking_hub_framework-field').append(error)
      } else if (element.parent().hasClass('bhub-form-field__input-wrapper')) {
        element.parents('.bhub-form-field').append(error)
      } else {
        error.appendTo(element.parent())
      }
    },
    highlight: function (element) {
      if ($(element).hasClass('bhub-custom-date-field__input')) {
        $(element).parents('.booking_hub_framework-field').addClass('error')
      } else {
        $(element).addClass('error')
      }
    },
    unhighlight: function (element) {
      if ($(element).hasClass('bhub-custom-date-field__input')) {
        $(element).parents('.booking_hub_framework-field').removeClass('error')
      } else {
        $(element).removeClass('error')
      }
    },
  }

  const settings = $.extend(true, {}, defaultSettings, options)

  this.find('select').each(function () {
    $(this).on('change', function () {
      $(this).valid()
    })
  })

  return this.each(function () {
    const $form = $(this)
    const validator = $form.validate(settings)

    if (settings.toggle && settings.toggle instanceof jQuery) {
      function toggle() {
        settings.toggle.prop('disabled', !$form.get(0).checkValidity())
      }

      $form.on('keyup change', 'input, select, textarea', toggle)

      $form.on('submit', toggle)
    }

    $form.data('bhubValidate', validator)

    $form[0].bhubValidate = {
      valid: () => validator.valid(),
      form: () => validator.form(),
      checkForm: () => validator.checkForm(),
      validator,
    }

    $form.bhubValidate = function () {
      return $form.data('bhubValidate').valid()
    }
  })
}
